/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxPasswordInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxpasswordinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcPasswordInputComponent),
    multi: true
};

/**
 * Password Input
 */
@Component({
    selector: 'ngc-passwordinput',
    template: `<jqxPasswordInput *ngIf="visible" (input)="inputChange($event)"
                [disabled] = "disabled"
                [localization] = "localization"
                [maxLength] = "maxLength"
                [placeHolder] = "placeHolder"
                [passwordStrength] = "passwordStrength"
                [rtl] = "rtl"
                [strengthColors] = "strengthColors"
                [showStrength] = "showStrength"
                [showStrengthPosition] = "showStrengthPosition"
                [strengthTypeRenderer] = "strengthTypeRenderer"
                [showPasswordIcon] = "showPasswordIcon"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                </jqxPasswordInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcPasswordInputComponent extends ControlComponent {
    @Input('localization') localization: any;
    @Input('maxLength') maxLength: any;
    @Input('placeHolder') placeHolder: any;
    @Input('passwordStrength') passwordStrength: any;
    @Input('rtl') rtl: any;
    @Input('strengthColors') strengthColors: any;
    @Input('showStrength') showStrength: any;
    @Input('showStrengthPosition') showStrengthPosition: any;
    @Input('strengthTypeRenderer') strengthTypeRenderer: any;
    @Input('showPasswordIcon') showPasswordIcon: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
}

/**
 * Password Input Module
 */
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcPasswordInputComponent],
    declarations: [NgcPasswordInputComponent, jqxPasswordInputComponent]
})
export class NgcPasswordInputModule {
}